import { createContext, useContext } from "react";

// import { JwtPayload } from "@aws-amplify/core/src/singleton/Auth/types";

interface JwtPayloadStandardFields {
  exp?: number;
  iss?: string;
  aud?: string | string[];
  nbf?: number;
  iat?: number;
  scope?: string;
  jti?: string;
  sub?: string;
}
type JsonPrimitive = null | string | number | boolean;
/** JSON array type */
type JsonArray = (JsonPrimitive | JsonObject | JsonArray)[];
/** JSON Object type */
interface JsonObject {
  [x: string]: JsonPrimitive | JsonArray | JsonObject;
}
export type JwtPayload = JwtPayloadStandardFields & JsonObject;

export type Role = "owner" | "trainer";

export interface UserInfo {
  isProfileCreated: boolean;
  accountId: string;
  role: Role;
  token: JwtPayload;
}

export interface JwtToken {
  payload: JwtPayload;
  toString(): string;
}

export const idTokenToUserInfo = (jwt: JwtPayload) =>
  ({
    token: jwt,
    isProfileCreated: !!jwt["custom:account_id"],
    accountId: jwt["custom:account_id"],
    role: jwt["custom:role"],
  }) as UserInfo;

export const UserContext = createContext<UserInfo>({} as UserInfo);

export const useUser = () => useContext(UserContext);
